import React, { useEffect, useState, useRef, useContext } from "react";
import { AccountDataList, AccountDetailslist, getProfitLoss, getShops, getUsers, getWarehouses, ListOrder, ListOrderMaster, ListSalesReport } from "../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import { currentDate, NaviGate, numberToWords } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import AccountsTable from "./AccountsTable";
import TrialBalance from "./TrialBalance";
import GeneralLedger from "./GeneralLedger";
import FinanceDashboard from "./FinanceDashboard";
import ProfitLoss from "./ProfitLoss";
import AccountsModule from "./AccountsModule";
import FinancialDashboard1 from "./FinancialDashboard1";

const AccountsList = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
  const [Order, setOrder] = useState([]);
  const [data, setData] = useState([]);
  const [accountsData, setAccountsData] = useState([]);
  const [fromDate, setFromDate] = useState(currentDate());
  const [toDate, setToDate] = useState(currentDate());
  const [trialData, setTrialData] = useState([]);

  useEffect(() => {
    fetchOrders();
    onReqTrialData();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or undefined date

    const date = new Date(dateString);
    if (isNaN(date)) return ""; // Ensure valid date

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
    // return `${day}/${month}/${year}`;
  };

  const fetchOrders = async () => {
    try {
      const formattedFromDate = formatDate(fromDate);
      const formattedToDate = formatDate(toDate);

      var filter = `from_date=${formattedFromDate}&to_date=${formattedToDate}`;
      var payload = {
        start_date: formattedFromDate,
        end_date: formattedToDate,
      }
      const response = await AccountDataList(filter);
      // const response = await AccountDetailslist(payload);
      if (response.data && response.data.data) {
        console.log(response.data);
        setData(response.data.data);
        // setAccountsData(response.data);
        // setOrder(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    fetchOrders();
  };

  const onReqTrialData = async (filterFromDate = '', filterToDate = '') => {
    try {
      const params = {};
      if (filterFromDate) params.start_date = filterFromDate;
      if (filterToDate) params.end_date = filterToDate;

      const res = await getProfitLoss(params);
      setTrialData(res.data.grouped_data || []);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="page-wrappers">
      <div className="page-content py-1">
        <NaviGate />
        {/* <FinancialDashboard1 /> */}
        {/* <AccountsModule /> */}
        <ProfitLoss
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          handleFilter={handleFilter}
          data={data} />
        {/* <FinanceDashboard />
        <TrialBalance data={data} />
        <GeneralLedger data={data} /> */}
        {/* <AccountsTable
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
          handleFilter={handleFilter}
          data={accountsData} /> */}
      </div>
    </div>
  );
};

export default AccountsList;
